<template>
	<div class="main_holder sections">

        <ul-sections-submenu :showyear="showYear"></ul-sections-submenu>
		
		<div class="content_holder">
	
			<router-view v-slot="{ Component }">
			<transition name="fade" mode="out-in">
				<component :is="Component" />
			</transition>
			</router-view>
		</div>
	</div>
</template>


<script>
    import SectionsSubMenu from './SectionsSubMenuWorkPlan.vue';

    export default {
        name: 'SectionsWorkPlan',
        components: {
            'ul-sections-submenu': SectionsSubMenu,
        },
        data: function() {
            return {
            }
		},
		computed: {
			showYear() {
				if (this.$route.name === 'sectionsDetailWorkPlan') { return false }
				else return true;
			}
		}
    }
</script>


<style lang="scss" scoped>
</style>
